import { mapGetters } from "vuex";

export default {
  data: () => ({

  }),

  mounted () {

  },
  methods: {
    
  },
  computed: {
    ...mapGetters([])
  },
}



// WEBPACK FOOTER //
// ./src/pages/Safety/safety.js